// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__BRUmg","logo":"styles_logo__9gUW0","navbar":"styles_navbar__bo1Vb","version":"styles_version__uh85B"};